import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  copy(e) {
    e.preventDefault();

    const url = window.location.href;
    navigator.clipboard.writeText(url)
      .then(() => {
        alert('URLをコピーしました。');
      }).catch(err => {
        alert('コピーに失敗しました。' + err);
      });
  }
}
